export const columnsOverview = [
  {
    title: '姓名',
    dataIndex: 'user',
    key: 'user',
    width: '100px',
    scopedSlots: { customRender: 'user' }
  },
  {
    title: 'Seed数',
    dataIndex: 'seedCount',
    key: 'seedCount',
    width: '100px'
  },
  {
    title: 'Venture数',
    dataIndex: 'ventureCount',
    key: 'ventureCount',
    width: '100px'
  },
  {
    title: 'Growth数',
    dataIndex: 'growthCount',
    key: 'growthCount',
    width: '100px'
  },
  {
    title: '项目领域',
    dataIndex: 'sectorList',
    key: 'sectorList'
    // width: '100px',
  },
  {
    title: 'notes数',
    dataIndex: 'notesCount',
    key: 'notesCount',
    width: '100px'
  }
];

// 排序
// https://blog.csdn.net/weixin_46880303/article/details/109532863?spm=1001.2101.3001.6650.1&utm_medium=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7ERate-1.pc_relevant_default&depth_1-utm_source=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7ERate-1.pc_relevant_default&utm_relevant_index=2

export const columnsDetailAll = [
  {
    title: '项目名',
    key: 'projectName',
    width: '100px',
    scopedSlots: { customRender: 'projectName' }
  },
  {
    title: '公司名',
    dataIndex: 'companyName',
    key: 'companyName',
    width: '100px'
  },
  {
    title: '项目状态',
    dataIndex: 'companyState',
    key: 'companyState',
    width: '100px'
  },
  {
    title: '时间优先级',
    dataIndex: 'priority',
    key: 'priority',
    width: '112px',
    scopedSlots: { customRender: 'priority' },
    // scopedSlots: { customRender: 'priority', title: 'priorityTitle' },
    sorter: (a, b) => a - b,
    sortDirections: ['descend', 'ascend']
  },
  {
    title: '综合',
    dataIndex: 'compositeScore',
    key: 'compositeScore',
    width: '72px',
    // scopedSlots: { title: 'scoreTitle' },
    filteredValue: null,
    sorter: (a, b) => a - b,
    sortDirections: ['descend', 'ascend']
  },

  {
    title: '市场',
    dataIndex: 'marketScore',
    key: 'marketScore',
    width: '72px',
    sorter: (a, b) => a - b,
    sortDirections: ['descend', 'ascend']
    // scopedSlots: { title: 'scoreTitle' }
  },
  {
    title: '团队',
    dataIndex: 'teamScore',
    key: 'teamScore',
    width: '72px',
    sorter: (a, b) => a - b,
    sortDirections: ['descend', 'ascend']
  },
  {
    title: '产品/技术',
    dataIndex: 'productScore',
    key: 'productScore',
    width: '100px',
    sorter: (a, b) => a - b,
    sortDirections: ['descend', 'ascend']
  },
  {
    title: '估值匹配',
    dataIndex: 'valuationMatchScore',
    key: 'valuationMatchScore',
    width: '100px',
    sorter: (a, b) => a - b,
    sortDirections: ['descend', 'ascend']
  },
  {
    title: 'DL',
    dataIndex: 'dealLeader',
    key: 'dealLeader',
    scopedSlots: { customRender: 'dealLeader' },
    width: '64px'
  },
  {
    title: '公司简介',
    dataIndex: 'brief',
    key: 'brief',
    width: '250px'
  },
  {
    title: '视频介绍',
    key: 'videoPresentation',
    width: '100px',
    scopedSlots: { customRender: 'videoPresentation' }
  },
  {
    title: '项目最大亮点',
    key: 'highlight',
    scopedSlots: { customRender: 'highlight' },
    width: '250px'
  },
  {
    title: '关键问题',
    key: 'keyProblem',
    scopedSlots: { customRender: 'keyProblem' },
    width: '250px'
  },
  {
    title: 'Deal Term',
    key: 'dealTerm',
    scopedSlots: { customRender: 'dealTerm' },
    width: '250px'
  },
  {
    title: 'To-Do',
    key: 'todo',
    scopedSlots: { customRender: 'todo' },
    width: '250px'
  },
  {
    title: '创建日期',
    dataIndex: 'createAt',
    key: 'createAt',
    scopedSlots: { customRender: 'createAt' },
    width: '100px',
    defaultSortOrder: 'descend',
    sortOrder: 'descend',
    sorter: (a, b) => a - b,
    sortDirections: ['descend', 'ascend']
  },
  {
    title: '更新日期',
    dataIndex: 'updateAt',
    key: 'updateAt',
    scopedSlots: { customRender: 'updateAt' },
    width: '100px',
    sorter: (a, b) => a - b,
    sortDirections: ['descend', 'ascend']
  }
];
